module.exports = __webpack_public_path__ + "img/Camden_Point_Marker.0db23e58.png";